import { IconType, WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';

export const WORKOUT_MODE_ICONS: Readonly<Record<WorkoutMode, IconType>> = {
  ftp: 'force',
  watts: 'watts',
  res: 'force',
  slope: 'slope',
  inc: 'slope',
  spd: 'speed',
  incSpd: 'audiences',
};

/** Icone utilisee quand aucun mode n'est defini (resistance par defaut). */
export const DEFAULT_WORKOUT_MODE_ICON: IconType = WORKOUT_MODE_ICONS.res;
